export function queryChildrenByParentId(axios, parentId) {
    return axios.get('/uni/api/node/queryChildrenByParentId', {
        params: {
            parentId: parentId
        }
    })
}


export function getNodeDetail(axios, nodeId) {
    return axios.get('/uni/api/node/detail', {
        params: {
            nodeId: nodeId
        }
    })
}


export function addNode(axios, parentId, name, type) {
    return axios.post('/uni/api/node/add', {
        parentId: parentId,
        nodeName: name,
        nodeType: type
    })
}

export function getRootNode(axios) {
    return axios.get('/uni/api/node/getRootNode')
}

export function queryNodeByName(axios, params) {
    return axios.get('/uni/api/node/query', {
        params: {
            name: params.name,
            type: params.type,
            deviceId: params.deviceId,
            channelId: params.channelId
        }
    })
}

// 查询未设置关联的NVR信息
export function queryUnbindNvr(axios) {
    return axios.get('/uni/api/node/queryDevice', {
        params: {
            page: 1,
            count: 999,
        }
    })
}

// 查询NVR关联的摄像头
export function queryNvrUnbindChannel(axios, id) {
    return axios.get('/uni/api/node/queryDeviceDetailByNodeId', {
        params: {
            page: 1,
            count: 999,
            nodeId: id,
        }
    })
}



export function postAddNodes(axios, data) {
    return axios.post('/uni/api/node/addNodes', {
        params: data
    })
}


export function deleteNode(axios, id) {
    return axios.post('/uni/api/node/delete', {
        id: id + "",
    })
}


// 获取子节点详情
export function queryChildrenDetailByParentId(axios, params) {
    return axios.get('/uni/api/node/queryByParentId', {
        params: {
            parentId: params.parentId,
            name: params.name,
            deviceId: params.deviceId,
            channelId: params.channelId,
            type: params.type,
            page: params.page,
            count: params.count,
        }
    })
}

export function queryNodeCanBeAdded(axios, id) {
    return axios.get('/uni/api/node/queryParentIdCanBeAdded', {
        params: {
            id: id
        }
    })
}


export function updateNodeInfo(axios, data) {
    return axios.post('/uni/api/node/update', data)
}


// WEBPACK FOOTER //
// ./src/api/tree.js